const helpers = {
    getImgDefault: function(url) {
        return (url !== '') ? url : process.env.REACT_APP_ASSETS_URL + 'images/img-default.jpg';
    },
    isEmpty: function(string) {
        return (string === '') ? true : false;
    }
}

export default helpers;